import React from 'react';

export const HrBold = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4987 3.05078H9.6987C7.5987 3.05078 5.8987 4.15078 4.9987 6.05078C4.8987 6.25078 4.9987 6.45078 5.0987 6.55078C5.1987 6.75078 5.3987 6.75078 5.5987 6.75078C6.8987 6.35078 9.8987 6.95078 11.1987 9.55078C12.6987 12.5508 11.2987 14.6508 10.5987 15.2508C10.4987 15.3508 10.3987 15.5508 10.3987 15.7508C10.3987 15.9508 10.4987 16.0508 10.6987 16.1508C11.6987 16.5508 13.3987 17.8508 13.3987 20.1508C13.3987 20.4508 13.5987 20.6508 13.8987 20.6508H17.3987C20.4987 20.6508 22.5987 18.4508 22.5987 15.2508V8.55078C22.6987 5.25078 20.5987 3.05078 17.4987 3.05078ZM16.1987 17.4516H18.4987C18.8987 17.4516 19.2987 17.0516 19.2987 16.6516C19.2987 16.1516 18.8987 15.8516 18.4987 15.8516H16.1987C15.6987 15.8516 15.3987 16.2516 15.3987 16.6516C15.3987 17.1516 15.7987 17.4516 16.1987 17.4516Z"
      fill="#64748B"
    />
    <path
      d="M9.59873 12.0516C9.59873 13.8516 8.19873 15.2516 6.39873 15.2516C4.59873 15.2516 3.19873 13.8516 3.19873 12.0516C3.19873 10.2516 4.59873 8.85156 6.39873 8.85156C8.19873 8.85156 9.59873 10.2516 9.59873 12.0516Z"
      fill="#64748B"
    />
    <path
      d="M1.69873 20.4516C1.69873 18.6516 3.19873 16.8516 6.39873 16.8516C9.59873 16.8516 11.0987 18.6516 11.0987 20.4516C11.0987 20.7516 10.8987 20.9516 10.5987 20.9516H2.19873C1.89873 20.9516 1.69873 20.7516 1.69873 20.4516Z"
      fill="#64748B"
    />
  </svg>
);
